// extracted by mini-css-extract-plugin
export var container = "_gy-0";
export var icon = "_gy-1";
export var text = "_gy-2";